import { type FC, type ReactNode } from "react";

import { clsx } from "clsx";

import { QuotaSeverityIcon } from "../../../shared/components/submission-quota/QuotaSeverityIcon";
import { SubmissionQuotaSeverity } from "../../../shared/models/SubmissionQuota";

import styles from "./SubmissionQuotaQuickView.module.css";
import { AlmostUsed, LimitReached, RunningLow } from "./messages.generated";

const statusContent: Record<Exclude<SubmissionQuotaSeverity, SubmissionQuotaSeverity.Normal>, ReactNode> = {
    [SubmissionQuotaSeverity.Warning]: <RunningLow />,
    [SubmissionQuotaSeverity.Urgent]: <AlmostUsed />,
    [SubmissionQuotaSeverity.Exhausted]: <LimitReached />,
};

export const QuotaStatus: FC<{ severity: SubmissionQuotaSeverity }> = ({ severity }) => {
    if (severity === SubmissionQuotaSeverity.Normal) {
        return null;
    }

    return (
        <span className={clsx(styles.status, styles[severity])} data-testid={`submission-quota-status-${severity}`}>
            <QuotaSeverityIcon severity={severity} />
            {statusContent[severity]}
        </span>
    );
};
